<template>
  <div class="content">
    <!-- <top-navbar></top-navbar> -->
    <div class="content report">
      <div
      :class="
        $store.state.errors != ''
          ? 'alert alert-danger text-center p-1 notifications active'
          : ''
      "
      v-if="$store.state.errors != ''"
    >
    <!-- <b-modal id="modal-error" hide-footer size="lg"> -->
      <button
        type="button"
        aria-hidden="true"
        class="close"
        @click="$store.state.errors = ''"
      >
        <b-icon font-scale="2" icon="x"></b-icon>
      </button>

      <h4>
        <i class="fas fa-exclamation-triangle"></i>&nbsp;
         {{ Interval() }}
      </h4>
      <p class="text-center">{{ $store.state.errors }}</p>
      <!-- </b-modal> -->
    </div>
    <router-view />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

// import TopNavbar from "./TopNavbar.vue";
import MobileMenu from "./MobileMenu.vue";
import $ from "jquery";
export default {
  components: {
    // TopNavbar,
    MobileMenu
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg"
    };
  },
  methods: {
    Interval() {
      setTimeout(() => {
        this.$store.state.errors = "";
      }, 3000);
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
    setTimeout(() => {
      $(".nav-link.active").focus();
    }, 1000);
    $("body").on("keydown", "a", function(e) {
      var self = $(this),
        focus = $(document.activeElement).attr("class"),
        table = self.parents(".md-list:eq(0)"),
        focusable,
        focused,
        focusable = table.find("li>a").filter(":visible");
      // past bosilsa keyingi qatorga tushish
      if (e.keyCode == 40) {
        focused = focusable.eq(focusable.index(this) + 1);
        if (focused.length) {
          focused.focus();
        } else {
          focusable.eq(0).focus();
        }
        //tepa bosilsa
      } else if (e.keyCode == 38) {
        var ind = focusable.index(this) - 1;
        focused = focusable.eq(ind);
        // tepasida bolamas qidiruvga focus berish
        if (ind < 0) {
          focusable.eq(focusable.index(this) - 1).focus();
          // tepasida bolsa shunga otish
        } else if (focused.length) {
          focused.focus();
        }
      } else if (e.keyCode == 13) {
        focused = focusable.eq(focusable.index(this));
        focused.click();
      } else if ((e.keyCode = 39)) {
        $(".content")
          .find("button")
          .eq(0)
          .focus();
      } else {
        return true;
      }
    });
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style></style>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
